import gql from 'graphql-tag'

export const INQUIRY_QUERY = gql`
  query inquiryName($id: ID!) {
    inquiry(id: $id) {
      name
    }
  }
`

export const CUSTOMER_QUERY = gql`
  query customerName($id: ID!) {
    customer(id: $id) {
      name
    }
  }
`

export const PARTNER_PROGRAM_QUERY = gql`
  query partnerProgramName($id: ID!) {
    partnerProgram(id: $id) {
      name
    }
  }
`

export const ASSET_CONTENT_QUERY = gql`
  query assetContentName($id: ID!) {
    assetContent(id: $id) {
      title
    }
  }
`

export const USER_QUERY = gql`
  query userName($id: ID!) {
    user(id: $id) {
      name
    }
  }
`

export const LOGISTIC_CENTER_QUERY = gql`
  query logisticCenterName($id: ID!) {
    logisticCenter(id: $id) {
      name
    }
  }
`

export const ORDER_QUERY = gql`
  query orderBreadcrumb($id: ID!) {
    order(id: $id) {
      id
    }
  }
`

export const BRAND_QUERY = gql`
  query brandName($id: ID!) {
    brand(id: $id) {
      name
    }
  }
`

export const BRAND_LINE_QUERY = gql`
  query brandLineName($id: ID!) {
    brandLine(id: $id) {
      name
    }
  }
`

export const COUNTRY_QUERY = gql`
  query countryName($id: ID!) {
    country(id: $id) {
      name
    }
  }
`
